import { render } from "./PostTags.vue?vue&type=template&id=497c0d01&scoped=true"
import script from "./PostTags.vue?vue&type=script&lang=js"
export * from "./PostTags.vue?vue&type=script&lang=js"

import "./PostTags.vue?vue&type=style&index=0&id=497c0d01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497c0d01"]])

export default __exports__